"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FullBar = function FullBar(props) {
  var propNames = ['left', 'middle', 'right']; //Top bar

  var left = Array.isArray(props.left) ? props.left.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "fullBarLeft-".concat(index),
      className: "item fullBarLetItem"
    }, element);
  }) : props.left;
  var middle = Array.isArray(props.middle) ? props.middle.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "fullBarMiddle-".concat(index),
      className: "item fullBarMiddleItem"
    }, element);
  }) : props.middle;
  var right = Array.isArray(props.right) ? props.right.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "fullBarRight-".concat(index),
      className: "item fullBarRightItem"
    }, element);
  }) : props.right;
  var contentPropUsed = Object.keys(props).filter(function (propName) {
    return propNames.includes(propName);
  });
  var hasMultiple = contentPropUsed.length > 1;
  var dynamicClasses = {
    "multipleCol": hasMultiple
  };
  if (contentPropUsed.length !== 0) dynamicClasses[contentPropUsed[0]] = !hasMultiple;
  var modalClasses = (0, _classnames["default"])("fullBar-component", props.className, dynamicClasses);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: modalClasses
  }, left && /*#__PURE__*/_react["default"].createElement("div", {
    className: "left"
  }, left), middle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "middle"
  }, middle), right && /*#__PURE__*/_react["default"].createElement("div", {
    className: "right"
  }, right));
};

FullBar.propTypes = {
  left: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  middle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  right: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  className: _propTypes["default"].string
};
FullBar.defaultProps = {};
var _default = FullBar;
exports["default"] = _default;